import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
  	if ($('#update-progress-delivery').attr('data-type') == "edit") {
	    $('#modal-header-delivery').removeClass('lg:flex')
      $('#update-progress-delivery').text("Update")
      $('#update-progress-delivery').attr('data-type', "edit")
      $('#delivery-header-title').text("Delivery Style") 
	  }
	}

}
